var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{style:({
      height: ((_vm.config.height) + "px"),
      'border-radius': ((_vm.config.radius_top) + "px " + (_vm.config.radius_top) + "px " + (_vm.config.radius_bottom) + "px " + (_vm.config.radius_bottom) + "px"),
      background: ("" + (_vm.config.color)),
      margin: ("0 " + (_vm.config.margin_num) + "px"),
    })})])}
var staticRenderFns = []

export { render, staticRenderFns }